import React from 'react';
import { IconProps } from '../IconProps';
const SvgNovaMessageTail = ({
  primaryColor,
  secondaryColor,
  tertiaryColor,
  ...props
}: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 29 30" fill="none" {...props}>
    <path
      d="M26.288 28.97a1.497 1.497 0 001.833-1.834L21.41 2.09a1.497 1.497 0 00-2.505-.671L.57 19.754a1.497 1.497 0 00.672 2.504l25.047 6.712z"
      fill={primaryColor}
    />
  </svg>
);
export default SvgNovaMessageTail;
